import React, { Component } from 'react'
import PropTypes from 'prop-types'
import RaisedButton from 'material-ui/RaisedButton'
import Alert from 'react-s-alert'
import LogoutIcon from '../assets/LogoutIcon'
import fetchApi from '../../services/fetchApi'
import { validatePassword, doPasswordsMatch } from '../../services/password-validation'
import css from './user-password.css'

const styles = {
  saveButton: {
    width: '100px',
    alignSelf: 'center',
    margin: '10px 0',
  },
}

class UserPassword extends Component {
  static propTypes = {
    username: PropTypes.string.isRequired,
  }

  static defaultProps = {
    username: 'n/a',
  }

  constructor(props) {
    super(props)

    this.state = {
      isSaveDisabled: true,
      curr_password: '',
      new_password: '',
      new_password_confirmation: '',
      hasError: false,
    }
  }

  attemptSave = (e) => {
    e.preventDefault()
    const { curr_password, new_password } = this.state

    if (!validatePassword(new_password)) {
      this.setState({ hasError: true })
      this.renderAlert('Your password is too short, must be 6 or more characters long')
    } else {
      const body = JSON.stringify({
        password: curr_password,
        new_password,
      })

      fetchApi('/account/password', 'POST', { body })
        .then(() => {
          this.setState({
            isSaveDisabled: true,
            curr_password: '',
            new_password: '',
            new_password_confirmation: '',
            hasError: false,
          })
          this.renderAlert('Successfully updated password', 'success')
        }).catch((error) => {
          console.log(error)
          this.setState({ hasError: true })
          const msg = error.body.error
          this.renderAlert(msg)
        })
    }
  }

  handlePassword = (ev) => {
    const newValue = ev.target.value
    this.setState({ curr_password: newValue })
  }

  handleNewPassword = (ev) => {
    const newValue = ev.target.value
    const { new_password_confirmation } = this.state

    let isSaveDisabled = true

    if (doPasswordsMatch(new_password_confirmation, newValue)) {
      isSaveDisabled = false
    }

    this.setState({
      new_password: newValue,
      isSaveDisabled,
    })
  }

  handleNewPasswordConfirmation = (ev) => {
    const newValue = ev.target.value
    const { new_password } = this.state

    let isSaveDisabled = true

    if (doPasswordsMatch(new_password, newValue)) {
      isSaveDisabled = false
    }

    this.setState({
      new_password_confirmation: newValue,
      isSaveDisabled,
    })
  }

  compareNewPasswords = () => {
    const { new_password, new_password_confirmation } = this.state

    if (!new_password || !new_password_confirmation) {
      return
    }

    if (!doPasswordsMatch(new_password, new_password_confirmation)) {
      this.renderAlert('Confirmation does not match your new password')
    }
  }

  /**
   * @param method, {string} one of: 'warning', 'error', 'info', 'success'
   */
  renderAlert = (msg, method = 'warning') => (
      Alert[method](msg, {
        position: 'top-right',
        effect: 'jelly',
        timeout: 5000,
        html: true,
        onClose: () => this.setState({ hasError: false }),
      })
    )

  render() {
    const { isSaveDisabled, curr_password, new_password, new_password_confirmation } = this.state

    return (
      <div className={css.wrapper}>
        <div>
          <h3 className={css.title}>Username</h3>
          <h4 className={css.username}>{this.props.username}</h4>
        </div>
        <form
          onSubmit={this.attemptSave}
        >
          <h3 className={css.title}>Change Password</h3>
          <input
            className={css.field}
            type="password"
            placeholder="current password"
            onChange={this.handlePassword}
            id="oldPassword"
            value={curr_password}
          />
          <input
            className={css.field}
            type="password"
            placeholder="new password"
            autoComplete="off"
            onChange={this.handleNewPassword}
            id="new_password"
            value={new_password}
          />
          <input
            className={css.field}
            placeholder="confirm new password"
            type="password"
            autoComplete="off"
            onChange={this.handleNewPasswordConfirmation}
            onBlur={this.compareNewPasswords}
            id="new_password_confirmation"
            value={new_password_confirmation}
          />
          <RaisedButton
            label="SUBMIT"
            primary
            type="submit"
            style={styles.saveButton}
            disabled={isSaveDisabled}
          />
        </form>
      </div>
    )
  }
}

export default UserPassword



// WEBPACK FOOTER //
// ./src/components/Account/UserPassword.js